module.exports = __webpack_public_path__ + "img/productWX_5.1de87420.png";